"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StreakCounterCountIcon = function (_a) {
    var variant = _a.variant, other = __rest(_a, ["variant"]);
    var fill = '#BDBDBD';
    if (variant === 'red') {
        fill = '#F44336';
    }
    if (variant === 'blue') {
        fill = '#81D4FA';
    }
    return (react_1.default.createElement("svg", __assign({}, other, { viewBox: "0 0 512 512" }),
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { fill: fill, d: "M304 1.52588e-05C194.887 62.8686 169.5 216.5 169.5 216.5C169.5 216.5 160 224 160 152C102.733 185.207 63.9998 249.033 63.9998 320C63.9998 426.039 149.961 512 256 512C362.039 512 448 426.039 448 320C447.999 164 304 132 304 1.52588e-05Z" }))));
};
exports.default = StreakCounterCountIcon;
//# sourceMappingURL=StreakCounterCountIcon.js.map